import { Pipe, PipeTransform } from '@angular/core';
import { formatPayRate } from './pay-rate-format';

/**
 * The one display format for an hourly pay rate (#35456): use `| payRate`, never `| currency`.
 */
@Pipe({
  name: 'payRate',
})
export class PayRatePipe implements PipeTransform {
  transform(value: number | string | null | undefined): string | null {
    return formatPayRate(value);
  }
}
